var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrowHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39995 14.3996H5.33329C5.12742 14.3996 4.93969 14.2807 4.85115 14.0945C4.76262 13.9084 4.78982 13.6881 4.92049 13.5281L9.44422 7.99961L4.92049 2.47054C4.78982 2.31108 4.76315 2.09081 4.85115 1.90414C4.93916 1.71748 5.12742 1.59961 5.33329 1.59961L6.39995 1.59961C6.55995 1.59961 6.71142 1.67161 6.81275 1.79534L11.6128 7.66201C11.7733 7.85881 11.7733 8.14094 11.6128 8.33774L6.81275 14.2044C6.71142 14.3276 6.55995 14.3996 6.39995 14.3996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrowHover);
export default __webpack_public_path__ + "static/media/rightarrow_hover.24cee2c88cacb8fd5e64c5c146db5639.svg";
export { ForwardRef as ReactComponent };